import { render, staticRenderFns } from "./InventoryItemVendors.vue?vue&type=template&id=86b5b234&scoped=true"
import script from "./InventoryItemVendors.vue?vue&type=script&lang=js"
export * from "./InventoryItemVendors.vue?vue&type=script&lang=js"
import style0 from "./InventoryItemVendors.vue?vue&type=style&index=0&id=86b5b234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b5b234",
  null
  
)

export default component.exports